export default {
  default: [
    {
      path: "/bank-verbindingen",
      name: "bank-connections",
      component: () => import("@/modules/bankAccounts/views/BankAccountsView.vue")
    },
    {
      path: "/bank-verbindingen/incasso-rekening-aanpassen",
      name: "update.sepa.account",
      component: () => import("@/modules/bankAccounts/views/UpdateSepaAccountView.vue")
    }
  ]
};
